import React from 'react';

import Toast, { ToastProps } from './index';
import styles from './styles.module.css';

export interface ToastContainerProps {
  toasts: Array<Omit<ToastProps, 'onClose'> & { createdAt?: number }>;
  onCloseToast: (id: string) => void;
  className?: string;
}

export const ToastContainer: React.FC<ToastContainerProps> = ({
  toasts,
  onCloseToast,
  className = ''
}) => {
  if (toasts.length === 0) {
    return null;
  }

  return (
    <div className={`${styles.toastContainer} ${className}`}>
      {toasts.map(toast => (
        <Toast key={toast.id} {...toast} onClose={onCloseToast} />
      ))}
    </div>
  );
};

export default ToastContainer;
